export type Formats = 'medium' | 'short' | 'shortDate' | 'shortTime';

export const predefinedDateTimeFormats: Record<
  Formats,
  Intl.DateTimeFormatOptions
> = {
  short: {
    timeStyle: 'short',
    dateStyle: 'short',
  },
  medium: {
    timeStyle: 'medium',
    dateStyle: 'medium',
  },
  shortDate: {
    dateStyle: 'short',
  },
  shortTime: {
    timeStyle: 'short',
  },
};
